import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import './styles.css'

const rootElement = document.getElementById('wtta-report-root')

if (!rootElement) {
  throw new Error('Missing #wtta-report-root element in index.html')
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
